module.exports = __webpack_public_path__ + "img/section1Swiper4.182ab3a9.png";